;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('cardCompanyPlans', cardCompanyPlans)

  function cardCompanyPlans () {
    return {
      restrict: 'E',
      scope: {
        data: '<',
        name: '@',
        type: '@',
        onClose: '&'
      },
      templateUrl: '/core/directives/card-company-plans/card-company-plans-directive.html?$$REVISION$$',
      controller: 'CardCompanyPlansController'
    }
  }
})()
